{
    "DisplayAsLabel": "Mostrar como:",
    "ColorTileBackgroundLabel": "Cor do painel:",
    "ColorTileTextLabel": "Cor do texto:",
    "FitImageLabel": "Ajustar a imagem",
    "DisplayTitleLabel": "Apresentar área de texto do título",
    "AutoValuePlaceholder": "[Auto]",
    "ImageUrlPlaceholder": "https:\/\/example.com\/image.png",
    "ImageUrlLabel": "Imagem URL:",
    "Black": "Preto",
    "White": "Branco",
    "Blanc": "Branco",
    "Smoke": "Fumaça",
    "Grey": "Cinza",
    "Battleship": "Navio de guerra",
    "Aqua": "Água",
    "Blue": "Azul",
    "Waters": "Águas",
    "Sky": "Céu",
    "Akixi": "Akixi",
    "Midnight": "Meia-noite",
    "Pistachio": "Pistache",
    "Green": "Verde",
    "Forest": "Floresta",
    "Salmon": "Salmão",
    "Red": "Vermelho",
    "Rosita": "Rosita",
    "Peach": "Pêssego",
    "Orange": "Laranja",
    "Clementine": "Clementina",
    "Amarelo": "Amarelo",
    "Yellow": "Amarelo",
    "Sunflower": "Girassol",
    "Lilac": "Lilás",
    "Purple": "Roxo",
    "Regal": "Régio",
    "Blush": "Corar",
    "Pink": "Rosa",
    "Fuchsia": "Fúcsia",
    "Caribbean": "Caribe",
    "Teal": "Cerceta",
    "Peacock": "Pavão",
    "SimpleTextValue": "[Valor de texto simples]",
    "ProgressRing": "Anel de progresso",
    "GradatedDial": "Marcação graduada",
    "GlideSlope": "Glide Slope",
    "Bullseye": "Alvo",
    "BarGauge": "Medidor de Barras",
    "ConeGauge": "Medidor de cone",
    "DashboardSpeedometerBlack": "Velocímetro do painel (preto)",
    "DashboardSpeedometerAmber": "Velocímetro do painel (âmbar)",
    "DashboardTemperatureGauge": "Medidor de temperatura do painel",
    "DashboardFuelGauge": "Medidor de combustível do painel",
    "DashboardPowerGauge": "Medidor de potência do painel",
    "DashboardColourGauge": "Medidor de cores do painel",
    "GaugeFaceLabel": "Face do medidor reverso:",
    "GaugeFaceDirection": "Direção reversa do medidor:",
    "MaxScaleLabel": "Escala máxima:",
    "DisplayPreviewCaption": "Pré-visualização:",
    "DisplaySettings_SectionHeader": "Definições de apresentação",
    "NAME": "DisplaySettings",
    "VividSky": "Céu vívido",
    "ElectricIndigo": "Índigo elétrico",
    "OxfordBlue": "Azul Oxford",
    "Aquamarine": "Água-marinha"
}